module.exports = __webpack_public_path__ + "static/img/course-standard.01840d9b.png";